export enum FeatureToggleFlags {
  OSR_FLOW_DISPLAY_SHELL = 'OSR_FLOW_DISPLAY_SHELL',
  OSR_FLOW_DISPLAY_SCHEDULE = 'OSR_FLOW_DISPLAY_SCHEDULE',
  OSR_FLOW_DISPLAY_STATUS = 'OSR_FLOW_DISPLAY_STATUS',
  OSR_FLOW_DISPLAY_HISTORY = 'OSR_FLOW_DISPLAY_HISTORY',
  OSR_PROFILE_SCORE = 'OSR_PROFILE_SCORE',
  STF_IOLM = 'STF_IOLM',
  OSR_MARKETING_COMMS = 'OSR_MARKETING_COMMS',
  OSR_WHATSAPP_COMMS = 'OSR_WHATSAPP_COMMS',
  OSR_WORKSHOP_AVAILABILITY = 'OSR_WORKSHOP_AVAILABILITY',
  OSR_AI_SUGGESTIONS = 'OSR_AI_SUGGESTIONS',
}
